/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionSeriesGame } from './CompetitionSeriesGame';
import {
    CompetitionSeriesGameFromJSON,
    CompetitionSeriesGameFromJSONTyped,
    CompetitionSeriesGameToJSON,
    CompetitionSeriesGameToJSONTyped,
} from './CompetitionSeriesGame';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { ScoreSubmissionResponse } from './ScoreSubmissionResponse';
import {
    ScoreSubmissionResponseFromJSON,
    ScoreSubmissionResponseFromJSONTyped,
    ScoreSubmissionResponseToJSON,
    ScoreSubmissionResponseToJSONTyped,
} from './ScoreSubmissionResponse';
import type { MatchReadinessResponse } from './MatchReadinessResponse';
import {
    MatchReadinessResponseFromJSON,
    MatchReadinessResponseFromJSONTyped,
    MatchReadinessResponseToJSON,
    MatchReadinessResponseToJSONTyped,
} from './MatchReadinessResponse';
import type { MatchParticipantInfoResponse } from './MatchParticipantInfoResponse';
import {
    MatchParticipantInfoResponseFromJSON,
    MatchParticipantInfoResponseFromJSONTyped,
    MatchParticipantInfoResponseToJSON,
    MatchParticipantInfoResponseToJSONTyped,
} from './MatchParticipantInfoResponse';
import type { CompetitionType } from './CompetitionType';
import {
    CompetitionTypeFromJSON,
    CompetitionTypeFromJSONTyped,
    CompetitionTypeToJSON,
    CompetitionTypeToJSONTyped,
} from './CompetitionType';
import type { MatchDisputeResponse } from './MatchDisputeResponse';
import {
    MatchDisputeResponseFromJSON,
    MatchDisputeResponseFromJSONTyped,
    MatchDisputeResponseToJSON,
    MatchDisputeResponseToJSONTyped,
} from './MatchDisputeResponse';
import type { MatchFormat } from './MatchFormat';
import {
    MatchFormatFromJSON,
    MatchFormatFromJSONTyped,
    MatchFormatToJSON,
    MatchFormatToJSONTyped,
} from './MatchFormat';
import type { CompetitionOverwolfVerification } from './CompetitionOverwolfVerification';
import {
    CompetitionOverwolfVerificationFromJSON,
    CompetitionOverwolfVerificationFromJSONTyped,
    CompetitionOverwolfVerificationToJSON,
    CompetitionOverwolfVerificationToJSONTyped,
} from './CompetitionOverwolfVerification';
import type { CompetitionMatchStatus } from './CompetitionMatchStatus';
import {
    CompetitionMatchStatusFromJSON,
    CompetitionMatchStatusFromJSONTyped,
    CompetitionMatchStatusToJSON,
    CompetitionMatchStatusToJSONTyped,
} from './CompetitionMatchStatus';

/**
 * Universal match record used across all competition types
 * @export
 * @interface Match
 */
export interface Match {
    /**
     * 
     * @type {string}
     * @memberof Match
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Match
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Match
     */
    updatedAt: number;
    /**
     * 
     * @type {CompetitionType}
     * @memberof Match
     */
    competitionType: CompetitionType;
    /**
     * ID of the parent competition (tournament, league, ladder, etc.)
     * @type {string}
     * @memberof Match
     */
    competitionId: string;
    /**
     * 
     * @type {CompetitionMatchStatus}
     * @memberof Match
     */
    status: CompetitionMatchStatus;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof Match
     */
    scoringMode: MatchScoringMode;
    /**
     * 
     * @type {MatchFormat}
     * @memberof Match
     */
    format: MatchFormat;
    /**
     * 
     * @type {MatchParticipantInfoResponse}
     * @memberof Match
     */
    participant1?: MatchParticipantInfoResponse;
    /**
     * 
     * @type {MatchParticipantInfoResponse}
     * @memberof Match
     */
    participant2?: MatchParticipantInfoResponse;
    /**
     * Winner participant ID
     * @type {string}
     * @memberof Match
     */
    winnerId?: string;
    /**
     * Whether the match ended in a draw
     * @type {boolean}
     * @memberof Match
     */
    isDraw: boolean;
    /**
     * Score submissions from participants
     * @type {Array<ScoreSubmissionResponse>}
     * @memberof Match
     */
    submissions?: Array<ScoreSubmissionResponse>;
    /**
     * 
     * @type {MatchDisputeResponse}
     * @memberof Match
     */
    dispute?: MatchDisputeResponse;
    /**
     * Scheduled start time (epoch ms)
     * @type {number}
     * @memberof Match
     */
    scheduledTime?: number;
    /**
     * Actual start time (epoch ms)
     * @type {number}
     * @memberof Match
     */
    startedAt?: number;
    /**
     * Completion time (epoch ms)
     * @type {number}
     * @memberof Match
     */
    completedAt?: number;
    /**
     * 
     * @type {CompetitionOverwolfVerification}
     * @memberof Match
     */
    overwolfVerification?: CompetitionOverwolfVerification;
    /**
     * 
     * @type {MatchReadinessResponse}
     * @memberof Match
     */
    readiness?: MatchReadinessResponse;
    /**
     * Individual games for Best-of-X formats
     * @type {Array<CompetitionSeriesGame>}
     * @memberof Match
     */
    seriesGames?: Array<CompetitionSeriesGame>;
    /**
     * Round or phase number (context-dependent per competition type)
     * @type {number}
     * @memberof Match
     */
    roundNumber?: number;
    /**
     * Match index within round (for ordering)
     * @type {number}
     * @memberof Match
     */
    matchIndex?: number;
}



/**
 * Check if a given object implements the Match interface.
 */
export function instanceOfMatch(value: object): value is Match {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('competitionType' in value) || value['competitionType'] === undefined) return false;
    if (!('competitionId' in value) || value['competitionId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('scoringMode' in value) || value['scoringMode'] === undefined) return false;
    if (!('format' in value) || value['format'] === undefined) return false;
    if (!('isDraw' in value) || value['isDraw'] === undefined) return false;
    return true;
}

export function MatchFromJSON(json: any): Match {
    return MatchFromJSONTyped(json, false);
}

export function MatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Match {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'competitionType': CompetitionTypeFromJSON(json['competitionType']),
        'competitionId': json['competitionId'],
        'status': CompetitionMatchStatusFromJSON(json['status']),
        'scoringMode': MatchScoringModeFromJSON(json['scoringMode']),
        'format': MatchFormatFromJSON(json['format']),
        'participant1': json['participant1'] == null ? undefined : MatchParticipantInfoResponseFromJSON(json['participant1']),
        'participant2': json['participant2'] == null ? undefined : MatchParticipantInfoResponseFromJSON(json['participant2']),
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
        'isDraw': json['isDraw'],
        'submissions': json['submissions'] == null ? undefined : ((json['submissions'] as Array<any>).map(ScoreSubmissionResponseFromJSON)),
        'dispute': json['dispute'] == null ? undefined : MatchDisputeResponseFromJSON(json['dispute']),
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
        'startedAt': json['startedAt'] == null ? undefined : json['startedAt'],
        'completedAt': json['completedAt'] == null ? undefined : json['completedAt'],
        'overwolfVerification': json['overwolfVerification'] == null ? undefined : CompetitionOverwolfVerificationFromJSON(json['overwolfVerification']),
        'readiness': json['readiness'] == null ? undefined : MatchReadinessResponseFromJSON(json['readiness']),
        'seriesGames': json['seriesGames'] == null ? undefined : ((json['seriesGames'] as Array<any>).map(CompetitionSeriesGameFromJSON)),
        'roundNumber': json['roundNumber'] == null ? undefined : json['roundNumber'],
        'matchIndex': json['matchIndex'] == null ? undefined : json['matchIndex'],
    };
}

export function MatchToJSON(json: any): Match {
    return MatchToJSONTyped(json, false);
}

export function MatchToJSONTyped(value?: Match | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'competitionType': CompetitionTypeToJSON(value['competitionType']),
        'competitionId': value['competitionId'],
        'status': CompetitionMatchStatusToJSON(value['status']),
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'format': MatchFormatToJSON(value['format']),
        'participant1': MatchParticipantInfoResponseToJSON(value['participant1']),
        'participant2': MatchParticipantInfoResponseToJSON(value['participant2']),
        'winnerId': value['winnerId'],
        'isDraw': value['isDraw'],
        'submissions': value['submissions'] == null ? undefined : ((value['submissions'] as Array<any>).map(ScoreSubmissionResponseToJSON)),
        'dispute': MatchDisputeResponseToJSON(value['dispute']),
        'scheduledTime': value['scheduledTime'],
        'startedAt': value['startedAt'],
        'completedAt': value['completedAt'],
        'overwolfVerification': CompetitionOverwolfVerificationToJSON(value['overwolfVerification']),
        'readiness': MatchReadinessResponseToJSON(value['readiness']),
        'seriesGames': value['seriesGames'] == null ? undefined : ((value['seriesGames'] as Array<any>).map(CompetitionSeriesGameToJSON)),
        'roundNumber': value['roundNumber'],
        'matchIndex': value['matchIndex'],
    };
}

